import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const notFoundEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-error-pages-not-found-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
